import { http } from "./http";
import { 
    SEARCH_SERVICE_SUBSCRIPTION_URL, 
    GET_SERVICE_AGREEMENT_URL, 
    SIGN_SERVICE_SUBSCRIPTION_URL, 
    PREVIEW_SERVICE_AGREEMENT_URL,
    GET_ACTIVE_SERVICES_URL
} from "./URL";

export const SERVICE_SUBSCRIPTION_SORT_FIELDS = [
    "userName",
    "userEmail",
    "signDatetime",
    "status",
] as const;

export type ServiceSubscriptionSortField = (typeof SERVICE_SUBSCRIPTION_SORT_FIELDS)[number];

export interface SearchServiceSubscriptionParams {
    serviceTypes?: string[];
    userName?: string;
    userEmail?: string;
    userStatus?: string[];
    currentPage: number;
    itemsPerPage: number;
    downloadState?: boolean;
    sortBy?: ServiceSubscriptionSortField;
    sortOrder?: "asc" | "desc";
}


/**
 * Search service subscriptions with filters
 * @param params Search parameters
 * @returns Promise with service subscription list
 */
export const searchServiceSubscriptions = async (params: SearchServiceSubscriptionParams) => {
    try {
        const response = await http.post(SEARCH_SERVICE_SUBSCRIPTION_URL, params);
        return response;
    } catch (error) {
        throw error;
    }
};

/**
 * Get service agreement by service name
 * @param serviceName Service name
 * @returns Promise with service agreement details
 */
export const getServiceAgreement = async (serviceName: string) => {
    try {
        const response = await http.get(`${GET_SERVICE_AGREEMENT_URL}/${serviceName}`);
        return response;
    } catch (error) {
        throw error;
    }
};

/**
 * Sign service subscription agreement
 * @param signData Signature data
 * @returns Promise with sign response
 */
export const signServiceSubscription = async (signData: any) => {
    try {
        const response = await http.post(SIGN_SERVICE_SUBSCRIPTION_URL, signData);
        return response;
    } catch (error) {
        throw error;
    }
};

/**
 * Preview service agreement
 * @param previewData Preview data
 * @returns Promise with preview response
 */
export const previewServiceAgreement = async (previewData: any) => {
    try {
        const response = await http.post(PREVIEW_SERVICE_AGREEMENT_URL, previewData);
        return response;
    } catch (error) {
        throw error;
    }
};

/**
 * Get all active services for dropdown
 * @returns Promise with list of active services
 */
export const getActiveServices = async () => {
    try {
        const response = await http.get(GET_ACTIVE_SERVICES_URL);
        return response.data?.data || [];
    } catch (error) {
        throw error;
    }
};
